<template>
  <v-main>
    <v-container fluid style="max-width: 400px;">
      <v-row>
        <v-col>
          <CenterContainer v-if="isPause">
            <div class="text-center">
              <v-icon class="ml-3" color="accent" size="50px">mdi-sleep</v-icon>
              <div class="mt-1">Die Woche ist pausiert</div>
              <div class="mt-3 body-2" v-if="!isTooLongPast">
                Einabe ist weiterhin möglich aber die Werte werden im
                Durchschnitt nicht berücksichtigt.
              </div>
            </div>
          </CenterContainer>
          <CenterContainer v-if="isTooLongPast" class="red--text">
            Datum zu weit in der Vergangenheit.<br/>
            Eingabe ist nur für die aktuelle und die letzte Woche möglich.
          </CenterContainer>
          <v-card>
            <v-card-title>
              Eingabe für {{ datum }}
              <v-spacer></v-spacer>
              <v-btn icon @click="show_picker=true">
                <v-icon>mdi-calendar</v-icon>
              </v-btn>
              <v-dialog v-model="show_picker" max-width="290">
                <v-card>
                  <v-card-text class="pa-0">
                    <v-date-picker v-model="iso_date" :first-day-of-week="1" locale="de" :event-color="getDotColor"
                                   :events="pickerMonthAvailability" :picker-date.sync="picker_date"/>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn width="100" color="gelb" class="white--text" @click="show_picker=false;">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-title>


            <div class="ml-5 mr-5 mt-5" v-if="hinweis">
              <p>
                <b>Achtung: Du hast noch keine Aktivitäten angelegt!</b>
              </p>
              <p>
                Damit du profitieren kannst, musst du deine <router-link class="blue--text" to="/activities">Aktivitäten festlegen</router-link>.
                Nimm dir bitte kurz dafür Zeit!
              </p>
              <p>
                Erst wenn du Aktivitäten eingerichtet hast, kannst du hier täglich deine Werte eingeben.
              </p>
            </div>

            <v-list>
              <v-list-group value="true" v-for="(bereich,i) in bereiche" :key="bereich.bid" color="accent"
                            style="border-top: 1px solid #dee1e6;position: relative; overflow: hidden;"
                            v-if="bereich.activities.length > 0 && bereich.type==='Index'"
                            v-model="bereich.selected">
                <!--                <div :style="`position: absolute; left: -130px; top:0; width: 200px; height: 100px; background-color: ${bereich.color}; transform: rotate(-20deg); z-index:0;`" ></div>-->
                <template v-slot:activator>
                  <!--                  <div :style="`position: absolute; left: -170px; top:0; width: 500px; height: 500px; background-color: ${bereich.color}; transform: rotate(-20deg); z-index:0;`" ></div>-->
                  <BgSlanted :style="`position: absolute; left:-350px; color: ${bereich.color};`"></BgSlanted>
                  <v-list-item-title style="position: relative; z-index: 1;" class="ml-2">
                    <div class="pb-2 d-flex" style="min-width: 0; position: relative;">
                      <!--                      <rocket :color="bereich.color" style="flex: 0 0 auto; height: 30px;"-->
                      <!--                              class="ml-n3 mr-0 mb-n2"></rocket>-->
                      <div class="pt-2"
                           style="text-overflow: ellipsis; flex: 1 1 auto;white-space: nowrap; overflow: hidden;">
                        {{ bereich.name }}
                      </div>
                      <div class="pt-2 grey--text ml-1" style="flex: 0 0 auto;">{{ bereichInfo(bereich) }}</div>
                    </div>
                  </v-list-item-title>
                </template>
                <v-divider></v-divider>
                <template v-for="(activity, j) in GetActivities(bereich)">
                  <v-list-item :key="activity.id"
                               @click="selected_activity=activity"
                               :style="{'background-color':activity==selected_activity ? '#f0f0f0' : 'white'}"
                               :disabled="!isEingabeToday(activity)">
                    <v-list-item-icon class="ml-0 mr-2">
                      <v-avatar color="white" size="30" class="my-n2">
                        <v-icon :color="bereich.color">mdi-flag</v-icon>
                      </v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="d-flex" style="width: 100%;">
                          <div class="d-flex flex-shrink-1 flex-grow-1 truncate">
                            <span class="truncate">{{ activity.name }}</span>
                          </div>
                          <div class="d-flex flex-shrink-0 flex-grow-1 grey--text">
                            <!--                            <v-icon color="light-green" v-if="(activity.record||{}).id">mdi-check</v-icon>-->
                            {{ activityInfo(activity) }}
                          </div>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <div v-if="activity==selected_activity"
                       style="background: #f0f0f0; color: black; caret-color: black;">
                    <v-divider></v-divider>
                    <activity-eingabe :activity="selected_activity" :activity-sums="activitySums" :targets="targets"
                                      :date="date" @saved="onSaved" :abgeschlossen="isAbgeschlossen || isTooLongPast">
                    </activity-eingabe>
                  </div>
                </template>
              </v-list-group>
              <v-divider></v-divider>
              <v-list-item key="wohlbefinden"
                           @click="selected_activity=wohlbefinden"
                           :style="{'background-color':wohlbefinden==selected_activity ? '#f0f0f0' : 'white', 'color':wohlbefinden==selected_activity ? '#8c9eff !important' : 'black'}">
                <v-list-item-icon class="mr-5">
                  <v-avatar color="white" size="30" class="">
                    <v-icon color="accent">mdi-emoticon-happy-outline</v-icon>
                  </v-avatar>
                </v-list-item-icon>
                <v-list-item-title>
                  <div class="d-flex" style="width: 100%;">
                    <div class="d-flex flex-shrink-1 flex-grow-1 truncate ml-1">
                      <span class="truncate">Wohlbefinden</span>
                    </div>
                    <div class="d-flex flex-shrink-0 flex-grow-0">
                      <v-icon color="light-green" v-if="(wohlbefinden.record||{}).id">mdi-check</v-icon>
                    </div>
                  </div>
                </v-list-item-title>
              </v-list-item>
              <div v-if="wohlbefinden==selected_activity && !isAbgeschlossen && !isTooLongPast"
                   style="background: #f0f0f0; color: black; caret-color: black;">
                <v-divider></v-divider>
                <activity-eingabe :activity="selected_activity" :activity-sums="activitySums" :targets="targets"
                                  :date="date" @saved="onSaved">
                </activity-eingabe>
              </div>
            </v-list>
          </v-card>

          <!--          tagesabschluss-->
          <CenterContainer class="mt-5" v-if="!isTooLongPast">
            <v-btn v-if="!isAbgeschlossen" color="accent" large @click="onTagesabschlussClick">
              <v-icon class="mr-3">mdi-check-bold</v-icon>
              Tag abschließen
            </v-btn>
            <div v-if="isAbgeschlossen">
              <CenterContainer>
                <div class="d-flex">
                  <div class="mt-1">Tag abgeschlossen</div>
                  <v-icon class="ml-3" color="light-green">mdi-rocket-launch-outline</v-icon>
                </div>
              </CenterContainer>
              <v-btn @click="onTagNichtAbgeschlossenClick" class="mt-5">
                Abschluss aufheben
              </v-btn>
            </div>
          </CenterContainer>

          <!--          woche pausieren-->
          <CenterContainer v-if="!isTooLongPast">
            <v-btn v-if="!isPause" large @click="onPauseClick">
              <v-icon class="mr-3">mdi-sleep</v-icon>
              Diese Woche pausieren
            </v-btn>
            <v-btn v-if="isPause" large @click="onPauseUndoClick" class="mt-5">
              <v-icon class="mr-3">mdi-sleep-off</v-icon>
              Doch nicht pausieren
            </v-btn>
          </CenterContainer>
        </v-col>
      </v-row>
      <div class="d-flex">
        <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/rNsrCGqJ9os" target="_blank">
          <v-icon class="mr-2">mdi-play-box-outline</v-icon> Videoanleitung
        </v-btn>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import BEREICHE from "@/components/Bereiche";
import Rocket from "@/components/Rocket";
import Kinds from "@/components/Kinds";
import ActivityEingabe from "@/components/ActivityEingabe";
import CenterContainer from "@/components/CenterContainer";

const {DateTime} = require("luxon");
import Datum from "@/components/Datum.js";
import Activity from "@/components/Activity";
import ActivityLibrary from "@/components/ActivityLibrary";
import {ArrayX} from "@/reusable/array_extensions";
import {formatIntLeadingZeros} from "@/pepper";
import BgSlanted from "@/components/BgSlanted";
import {Ziele} from "@/components/Ziele";
import {Duration} from "luxon";

export default {
  name: "Eingabe",
  components: {BgSlanted, CenterContainer, Rocket, ActivityEingabe},
  data() {
    return {
      date: new Date(Date.now()),
      hinweis: false,
      dateTime: undefined,
      show_picker: false,
      picker_date: undefined,
      all_activities: [],
      bereiche: [],
      selected_activity: undefined,
      availabilities: {}, // contains info for each month browsed in picker whether or not records exist on every day
      wohlbefinden: {
        id: 'happyness',
        name: 'Wohlbefinden',
        record: {},
      },
      targets: undefined,
      currentTargets: undefined,
      activitySums: {},
      tagesabschluss: {},
    }
  },
  async mounted() {
    if (!this.$app.is_logged_in) {
      this.$store.commit("set", {key: "intern", value: false});
      if (this.$route.path != "/")
        this.$router.replace("/login?returnTo="+this.$route.path);
      return;
    }
    this.$store.commit("set", {key: "intern", value: true});
    if (this.$route.params.date)
      this.date = new Date(this.$route.params.date);
    // default bereiche. könnten später noch ergänzt werden.
    this.$app.bereiche.filter(x => !x.ignore).forEach(bereich => {
      var b = {
        bid: bereich.bid,
        type: bereich.type,
        name: bereich.name,
        color: BEREICHE.COLORS_BY_NAME[bereich.bid],
        activities: [],
        selected: undefined
      };
      this.bereiche.push(b);
    });
    console.log("bereiche:", this.bereiche)
    await this.load();
  },
  beforeRouteUpdate(to, from, next) {
    var isoDate = to.params.date;
    console.log("beforeRouteUpdate", isoDate);
    if (isoDate)
      this.dateChanged(isoDate)
    next();
  },
  methods: {
    async load() {
      this.dateTime = DateTime.fromJSDate(this.date);
      // load targets
      var app = this.$app;
      this.targets = (await this.$backend.get_object(Kinds.KIND_ZIELE, Ziele.makeId(this.dateTime.year)) || {});
      this.currentTargets = new Ziele(this.targets).getCurrentTargets();
      // load activities
      this.all_activities = [];
      var activities = await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY) || [];
      activities = ActivityLibrary.filterActivitiesByDate(activities, this.dateTime);
      if (activities.length === 0)
        this.hinweis=true;
      var bereicheByName = {};
      if (!this.bereiche)
        return;
      this.bereiche.forEach(b => {
        b.activities = [];
        bereicheByName[b.bid] = b
      });
      if (!activities)
        return;
      activities.forEach(x => x.sortKey ||= 0);
      activities = new ArrayX(activities).sortBy(a => a.sortKey);
      activities.forEach(activity => {
        if (!activity.name)
          return;
        if (!this.isEingabeToday(activity))
          return;
        var target = this.getCurrentTarget(activity);
        console.log("Ziel für Activity: " + activity.name, {target, activity})
        if (target === 0 && !(activity.freq === ActivityLibrary.FREQ_DAILY && activity.type === ActivityLibrary.TYPE_BOOL))
          return;
        var b = bereicheByName[activity.bereich];
        if (!b)
          return;
        b.activities.push(activity);
      });
      this.bereiche.forEach(b => {
        //b.activities.sort((a,b)=> a.name > b.name ? 1 : -1);
        b.activities.forEach(a => {
          this.all_activities.push(a);
        });
      });
      if (this.all_activities.length > 0)
        this.selected_activity = this.all_activities[0];
      var b = this.getBereichForActivity(this.selected_activity);
      if (b)
        this.$set(b, 'selected', this.selected_activity);
      this.activitySums = (await this.$backend.get_object(Kinds.KIND_ACTIVITY_SUMS, Datum.getStartOfWeekIso(this.date)) || {});
      this.load_records(this.date);
    },
    getCurrentTarget(activity) {
      if (!this.currentTargets)
        return activity.target * (ActivityLibrary.FREQ_DAILY ? 7 : 1);
      if (this.currentTargets.hasOwnProperty(activity.id))
        return this.currentTargets[activity.id];
      return undefined;
    },
    getDateTime() {       //  <-- NOTE: this returns a luxon DateTime
      var date = DateTime.fromJSDate(this.date || new Date(Date.now())).startOf('day');
      return date;
    },
    dateChanged(value) {
      var newdate = new Date(value);
      if (newdate === this.date)
        return;
      this.date = newdate;
      this.dateTime = DateTime.fromJSDate(this.date);
      this.load();
    },
    load_records() {
      this.all_activities.forEach(a => {
        this.load_record(a, this.date);
      });
      this.load_record(this.wohlbefinden, this.date);
      this.load_tagesabschluss();
    },
    async load_record(activity, date) {
      var id = Activity.makeRecordId(Datum.to_iso(date), activity.id);
      var record = await this.$backend.get_object(Kinds.KIND_RECORD, id);
      if (!record) {
        this.$set(activity, 'record', undefined);
        return;
      }
      this.$set(activity, 'record', record);
    },
    async load_tagesabschluss() {
      var date = this.getDateTime();
      var id = Activity.makeRecordId(date.toISODate(), "tagesabschluss");
      var record = await this.$backend.get_object(Kinds.KIND_RECORD, id);
      this.tagesabschluss = record;
    },
    onSaved(activity) {
      var idx = this.all_activities.findIndex(x => x === activity);
      if (activity.id === 'happyness')
        return;
      if (idx < 0)
        return;
      if (idx >= this.all_activities.length) {
        this.selected_activity = this.wohlbefinden;
        return;
      }
      // select next activity
      while (idx < this.all_activities.length) {
        idx++
        var a = this.all_activities[idx];
        if (a && !a.record) {
          this.selected_activity = a;
          break;
        }
      }
      if (idx >= this.all_activities.length) {
        this.selected_activity = this.wohlbefinden;
        return;
      }
      this.bereiche.forEach(b => {
        if (b.bid === this.selected_activity.bereich)
          b.selected = this.selected_activity;
      });
    },
    async onTagesabschlussClick() {
      var date = this.getDateTime();
      var id = Activity.makeRecordId(date.toISODate(), "tagesabschluss");
      var record = {id, activity: "tagesabschluss", date: date.toISODate(), value: "abgeschlossen"};
      record = await this.$backend.set_object(Kinds.KIND_RECORD, id, record);
      console.log("Saved tagesabschluss:", record);
      this.tagesabschluss = record;
      this.$events.$emit("update_streak");
      setTimeout(() => this.$router.push("/dashboard"), 1000);
    },
    async onTagNichtAbgeschlossenClick() {
      var date = this.getDateTime();
      var id = Activity.makeRecordId(date.toISODate(), "tagesabschluss");
      var record = {id, activity: "tagesabschluss", date: date.toISODate(), value: undefined};
      record = await this.$backend.set_object(Kinds.KIND_RECORD, id, record);
      console.log("Saved tagesabschluss:", record);
      this.tagesabschluss = record;
      this.$events.$emit("update_streak");
    },
    async onPauseClick() {
      await this.savePause(true);
    },
    async onPauseUndoClick() {
      await this.savePause(false);
    },
    async savePause(isPause) {
      var id = Datum.getStartOfWeekIso(this.date);
      // index
      var index = await this.$backend.get_object(Kinds.KIND_INDEX, id) || {};
      if (!index.date)
        index.date = id;
      if (!index.__owner__)
        index.__owner__ = this.$app.user.email;
      if (!index.id)
        index.id = id;
      index.pause = isPause;
      await this.$backend.set_object(Kinds.KIND_INDEX, id, index);
      // activitySums
      var actiSums = this.activitySums;
      actiSums.pause = isPause;
      if (!actiSums.__owner__)
        actiSums.__owner__ = this.$app.user.email;
      if (!actiSums.id)
        actiSums.id = id;
      actiSums = await this.$backend.set_object(Kinds.KIND_ACTIVITY_SUMS, id, actiSums);
      this.activitySums = actiSums || {};
      console.log("savePause:", actiSums);
    },
    getBereichForActivity(activity) {
      return this.bereiche.find(b => b.bid === activity.bereich);
    },
    GetActivities(bereich) {
      return bereich.activities.filter(a => this.isEingabeToday(a));
    },
    isEingabeToday(a) {
      var eingabe = false;
      if ((a.input || ActivityLibrary.INPUT_DAILY) === ActivityLibrary.INPUT_DAILY) eingabe = true;
      if (this.dateTime.weekday == 1 && a.input == ActivityLibrary.INPUT_MO) return true;
      if (this.dateTime.weekday == 2 && a.input == ActivityLibrary.INPUT_DI) return true;
      if (this.dateTime.weekday == 3 && a.input == ActivityLibrary.INPUT_MI) return true;
      if (this.dateTime.weekday == 4 && a.input == ActivityLibrary.INPUT_DO) return true;
      if (this.dateTime.weekday == 5 && a.input == ActivityLibrary.INPUT_FR) return true;
      if (this.dateTime.weekday == 6 && a.input == ActivityLibrary.INPUT_SA) return true;
      if (this.dateTime.weekday == 7 && a.input == ActivityLibrary.INPUT_SO) return true;
      //console.log("Eingabe => " + a.name + " => " + a.input + " => " + (eingabe ? "ja" : "#### NEIN ###"));
      return eingabe;
    },
    async getRecordAvailabilityForPickerDate() {
      var id = this.picker_date || this.date.toISOString().substr(0, 7); // YYYY-MM
      // if (this.availabilities[id])
      //   return;
      var availability = await this.$backend.get_object(Kinds.KIND_RECORD_AVAILABILITY, id) || {};
      this.$set(this.availabilities, id, availability);
    },
    getDotColor(date) {
      var green = "green lighten-1";
      var yellow = "yellow";
      var iso = Datum.to_iso(date);
      var availability = this.availabilities[this.picker_date];
      if (availability[iso] === true)
        return green;
      else
        return yellow;
    },
    bereichInfo(bereich) {
      //console.log({bereich});
      var numActis = bereich.activities.length;
      var numInputActis = bereich.activities.filter(a => a.record).length;
      return `(${numInputActis}/${numActis})`;
    },
    activityInfo(activity) {
      //console.log({activity});
      if (!activity)
        return "";
      if (!this.isAbgeschlossen && !activity.record)
        return "";
      var r = activity.record || {};
      if (activity.type == "Ja/Nein")
          //return r.value ? activity.positiv : activity.negativ;
        return r.value ? "Ja" : "Nein";
      var unit = activity.unit;
      if (unit === "Stunden" || unit === "Minuten" || unit === "Zeit") {
        var h = 0;
        var m = 0;
        if ((unit == "Minuten" || unit == "Zeit") && r.value) {
          h = Math.trunc(r.value / 60);
          m = Math.round(r.value % 60);
        } else if (unit == "Stunden" && r.value) {
          h = Math.trunc(r.value);
          m = Math.round((r.value - h) * 60);
        }
        return "" + formatIntLeadingZeros(h || 0, 2) + ":" + formatIntLeadingZeros(m || 0, 2);
      }
      return `${Math.round(r.value || 0)} ${activity.unit || "mal"}`;
    },
  },
  computed: {
    iso_date: {
      get() {
        return this.date.toISOString().substr(0, 10);
      },
      set(value) {
        this.$router.push("/eingabe/" + value)
        this.dateChanged(value);
      }
    },
    datum() {
      return Datum.short_de(this.date);
    },
    pickerMonthAvailability() {
      if (!this.picker_date)
        return [];
      var availability = this.availabilities[this.picker_date];
      if (!availability)
        return [];
      return [...Object.keys(availability).filter(x => x.startsWith("20"))];
    },
    isTooLongPast() {
      //return false;
      var lastMonday=DateTime.fromJSDate(new Date(Date.now())).startOf("week").minus(Duration.fromObject({days:7}));
      return(lastMonday>DateTime.fromJSDate(this.date));
    },
    isAbgeschlossen() {
      if (!this.tagesabschluss)
        return false;
      return this.tagesabschluss.value === "abgeschlossen";
    },
    isPause() {
      return !!this.activitySums["pause"];
    }
  },
  watch: {
    date() {
      this.load_records(this.date);
      this.selected_activity = undefined;
    },
    show_picker() {
      this.getRecordAvailabilityForPickerDate();
    },
    picker_date() {
      if (!this.picker_date)
        return;
      this.getRecordAvailabilityForPickerDate();
    }
  }
}
</script>

<style scoped>
.truncate {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .v-list-item__title {
  color: black;
}

</style>